import { cn } from '../../lib/utils';

const statusStyles = {
  compliant: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  pending: 'bg-slate-50 text-slate-600 border-slate-200',
  gap: 'bg-red-50 text-red-700 border-red-200',
  open: 'bg-amber-50 text-amber-700 border-amber-200',
  mitigated: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  accepted: 'bg-blue-50 text-blue-700 border-blue-200',
  draft: 'bg-slate-50 text-slate-600 border-slate-200',
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  archived: 'bg-slate-50 text-slate-500 border-slate-200',
};

export const StatusBadge = ({ status, className }) => {
  const style = statusStyles[status] || statusStyles.pending;
  
  return (
    <span 
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize',
        style,
        className
      )}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
